import type { ReactNode } from 'react';
import U2000AutoCompleteResultKeyboardHints from './U2000AutoCompleteResultKeyboardHints';

/** Classes pour la grille dans un popup : occupe l’espace disponible au-dessus du footer clavier. */
export const U2000_AUTOCOMPLETE_PANEL_RESULT_TABLE_CLASS = 'mt-0! min-h-0 flex-1';

type U2000AutoCompletePanelResultsBlockProps = {
  highlightedIndex: number;
  children: ReactNode;
};

/** Zone résultats (grille extensible) + indices clavier collés sous la grille. */
const U2000AutoCompletePanelResultsBlock: React.FC<U2000AutoCompletePanelResultsBlockProps> = ({
  highlightedIndex,
  children,
}) => (
  <div className="flex min-h-0 flex-1 flex-col gap-0.5 overflow-hidden">
    {children}
    <U2000AutoCompleteResultKeyboardHints highlightedIndex={highlightedIndex} />
  </div>
);

export default U2000AutoCompletePanelResultsBlock;
